import { createSelector } from 'reselect';
import {
    isCloudServicesPageLoadingSelector,
    isIntegrationsLoadingSelector,
    isIntegrationsSelector,
} from '../selectors';

/**
 * Memoized selector that aggregates loading and integrations status flags
 * for use on the Ezlo Projects Settings page.
 *
 * @function
 * @returns {Object} An object containing:
 *   @property {boolean} isIntegrationsLoading - Whether integrations are currently loading.
 *   @property {boolean} isIntegrations - Whether integrations exist/enabled.
 *   @property {boolean} isLoading - Whether the cloud services page is loading.
 *
 * @example
 * // Usage in a component:
 * const { isIntegrationsLoading, isIntegrations, isLoading } = useSelector(ezloParjectsSettingsSelector);
 */
export const ezloParjectsSettingsSelector = createSelector(
    [isIntegrationsLoadingSelector, isIntegrationsSelector, isCloudServicesPageLoadingSelector],
    (isIntegrationsLoading, isIntegrations, isLoading) => ({
        isIntegrationsLoading,
        isIntegrations,
        isLoading,
    }),
);
